<template>
  <div class="d-flex">
    <v-btn v-if="refresh" text icon x-large color="blue darken-2" @click="clickRefresh()">
      <v-icon>
        mdi-cached
      </v-icon>
    </v-btn>

    <i-button
      v-for="btn in buttonList"
      :key="`btn_${btn.id}`"
      color="btn_bg"
      :iconPre="true"
      :icon="btn.icon"
      :text="btn.text"
      :role="`${btn.id}`"
      @click="clickButton(btn)"
      :disabled="disabled(btn)"
    />

    <v-menu v-if="usePrint" content-class="report-menu" offset-y :close-on-click="true">
      <template v-slot:activator="{ on }">
        <!-- i-button 같은 템플릿으로 한번 감쌀경우 적용이 안되어 v-btn 사용 -->
        <v-btn
          class="rounded-0 ml-1 font-weight-bold pr-7 pl-1 pr-md-6"
          outlined
          v-on="on"
          color="btn_bg"
          :style="`height: 30px;`"
          fontWeight="13px"
          height="30px"
          max-height="30px"
          min-height="30px"
          :role="`${printButton.id}`"
        >
          <v-icon class="float-left" :color="fontColor"> ${{ printButton.icon }} </v-icon>

          <div class="float-center mx-1" :style="computedFontStyle">
            {{ printButton.text }}
          </div>
        </v-btn>
      </template>
      <div v-for="(reportbtn, index) in reportItems" :key="`btn_${reportbtn.role}`">
        <v-divider v-if="index !== 0" style="" />
        <v-btn width="100%" depressed text class="px-3" @click="clickButton(reportbtn)">
          {{ reportbtn.title }}
        </v-btn>
      </div>
    </v-menu>
  </div>
</template>

<script>
import localStore from '@/utils/localStore'
import iButton from './iButton.vue'
import store from '@/store'

export default {
  components: { iButton },
  name: 'i-button-list',
  props: {
    useBtnList: {
      type: Array,
      default: () => ['']
    },
    unUseBtnList: {
      type: Array,
      default: () => ['']
    },
    customBtnList: {
      type: Array,
      default: () => []
    },
    refresh: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // computedFontStyle() {
    //   let fontColor = this.fontColor
    //   if (this.disabled) {
    //     fontColor = 'content'
    //   }
    //   return {
    //     color: '#000',
    //     'font-size': this.fontSize + 'px',
    //     'letter-spacing': '0.5px',
    //     'font-weight': this.fontWeight,
    //     'line-height': 1.8
    //   }
    // },
    disabled() {
      return btn => {
        const result = this.$_.some(this.unUseBtnList, function(el) {
          return el === btn.id
        })

        // console.log('this.unUseBtnList', this.unUseBtnList)
        // console.log('btn', btn.id)
        // console.log('result', result)

        return result
      }
    }
    // disabled(btn) {
    //   return this.$_.find(this.unUseBtnList, function(el) {
    //     return false
    //   })
    // }
  },
  data() {
    return {
      // icon은 assets/theme/vuetify/ 적용되고 있는 esg0x.js 참조
      buttonList: [
        { id: 'btnInitialization', text: 'initialization', icon: 'pencil' },
        { id: 'btnCorrection', text: 'correction', icon: 'pencil' },
        { id: 'btnSearch', text: 'search', icon: 'search' },
        { id: 'btnAdd', text: 'Add', icon: 'plus' },
        { id: 'btnNew', text: 'New', icon: 'plus' },
        { id: 'btnSave', text: 'Save', icon: 'save' },
        { id: 'btnDelete', text: 'Delete', icon: 'delete' },
        { id: 'btnDeleteAll', text: 'Delete All', icon: 'delete' },
        { id: 'btnDeleteSelect', text: 'Delete Select', icon: 'delete' },
        { id: 'btnPrint', text: 'Print', icon: 'print' },
        { id: 'btnPrintDetail', text: 'Print Detail', icon: 'print' },
        { id: 'btnClose', text: 'Close', icon: 'close' },
        { id: 'btnConfirm', text: 'confirm', icon: 'confirm' },
        { id: 'btnCancel', text: 'cancel', icon: 'cancel' },
        { id: 'btnEditCancel', text: 'reload', icon: 'reload' },
        { id: 'btnCapture', text: 'camera', icon: 'camera' },
        { id: 'btnApply', text: 'apply', icon: 'apply' },
        { id: 'btnCopy', text: 'Copy Series', icon: 'copy' },
        { id: 'btnUpload',text: 'Upload' , icon: 'upload' },
        { id: 'btnExcel',text: 'Excel' , icon: 'excel' },
        { id: 'btnSaveExcel',text: 'Save Excel' , icon: 'excel' },
        //
        { id: 'btnRetrieve', text: 'Retrieve', icon: 'search' },
        { id: 'btnPorSheet',text: 'POR Sheet' , icon: 'print' },
        { id: 'btnBomList',text: 'BOM List' , icon: 'print' },
        { id: 'btnBomListToExcel',text: 'BOM List to Excel' , icon: 'excel' },
        { id: 'btnReceiptRequest',text: 'Receipt Request' , icon: 'save' },
        { id: 'btnReceipt',text: 'Receipt P.O' , icon: 'save' },
        { id: 'btnPrintRequest',text: 'Print Request' , icon: 'print' },
        { id: 'btnPrintRequestVn',text: 'Print Request(VN)' , icon: 'print' },
        { id: 'btnPrintPo',text: 'Print P.O Sheet' , icon: 'print' },
        { id: 'btnDelivery',text: 'Delivery' , icon: 'change_menu' },
        { id: 'btnPoList',text: 'P.O List' , icon: 'change_menu' },
        { id: 'btnSuccessList',text: 'Success List' , icon: 'change_menu' },
        { id: 'btnMakeBidding',text: 'Make Bidding' , icon: 'change_menu' },
        { id: 'btnSubmitQuot',text: 'Submit Quot.' , icon: 'save' },
        { id: 'btnSubmitPI',text: 'Submit P/I' , icon: 'save' },
        { id: 'btnSubmitToHVS',text: 'Submit to HVS' , icon: 'save' },
        { id: 'btnMakeQuotation',text: 'Make Quotation' , icon: 'change_menu' },
        { id: 'btnMakePI',text: 'Make P/I' , icon: 'change_menu' },
        { id: 'btnSubmitBidding',text: 'Submit Bidding' , icon: 'save' },
        { id: 'btnViewDetail',text: 'View Detail' , icon: 'change_menu' },
        { id: 'btnList',text: 'List' , icon: 'change_menu' },
        { id: 'btnRequestList',text: 'Request List' , icon: 'change_menu' },
        { id: 'btnPipeListSaveAsExcel',text: 'Pipe List Save as Excel' , icon: 'excel' },
        { id: 'btnExportToExcel',text: 'Export to Excel' , icon: 'excel' },
        { id: 'btnImportFromExcel',text: 'Import from Excel' , icon: 'excel' },
        { id: 'btnSelect',text: 'Select' , icon: 'apply' },
        { id: 'btnSaveRequest',text: 'Save Request' , icon: 'save' },
        { id: 'btnPrintTag',text: 'Print Tag' , icon: 'print' },
        { id: 'btnMakeRequest',text: 'Make Request' , icon: 'save' },
        { id: 'btnUpdate',text: 'Update' , icon: 'save' },
        { id: 'btnOutsideInsp',text: 'Outside Insp. Status' , icon: 'change_menu' },
        { id: 'btnRequestInsp',text: 'Request Outside Insp' , icon: 'change_menu' },
        { id: 'btnApplyRequest',text: 'ITP APPLY REQUEST' , icon: 'save' },
        { id: 'btnSendRequest',text: 'Send Request' , icon: 'save' },
        { id: 'btnMakeNdt',text: 'Make NDT Request' , icon: 'save' },
        { id: 'btnSaveInfo',text: 'Save Info' , icon: 'save' },
        { id: 'btnViewOrModify',text: 'View or Modify' , icon: 'change_menu' },
        { id: 'btnPrintDelivery',text: 'Print Delivery' , icon: 'print' },
        { id: 'btnMakeDeliNote',text: 'Make Deli. Note' , icon: 'save' },
        { id: 'btnNdtRequest',text: 'NDT APPLY REQUEST' , icon: 'save' },
        { id: 'btnMakeInspectionRequest',text: 'Make Inspection Request' , icon: 'save' },
        { id: 'btnPrintSheet',text: 'PRINT SHEET' , icon: 'print' },
        { id: 'btnReInspectionApply',text: 'Re-Inspection Apply' , icon: 'save' },
        { id: 'btnApplyRequestInsp',text: 'APPLY REQUEST INSPECTION' , icon: 'save' },
        { id: 'btnApplyRequestPop',text: 'RE-INSPECTION' , icon: 'save' },
        { id: 'btnDevide', text: 'Devide' , icon: 'save' },
        { id: 'btnSendHvs', text: 'Send HVS' , icon: 'save' },
        { id: 'btnSaveAsExcel', text: 'Save As Excel' , icon: 'save' },
        { id: 'btnChange', text: 'Change' , icon: 'change' },
        { id: 'btnCreate', text: 'Create' , icon: 'plus' }
      ],
      progCd: this.$route.meta.proc_cd,
      menuId: this.$route.query == undefined ? '' : this.$route.query.selMenuid,
      savAh: '', //저장
      schAh: '', //조회
      delAh: '', //삭제
      exlAh: '', //엑셀출력(프린트)
      fn1Ah: '', //기능1
      fn2Ah: '', //기능2
      fn3Ah: '', //기능3
      usePrint: false,
      printButton: null,
      reportItems: [
        { role: 'pptx', title: 'PPT' },
        { role: 'pdf', title: 'PDF' },
        { role: 'docx', title: 'DOCX' },
        // { role: 'html', title: 'WEB'},
        { role: 'xls', title: 'EXCEL' }
      ],
      fontColor: '#000'
    }
  },
  created() {
    this.setBtns()
  },
  mounted() {
    // this.getAuthority()
    // this.printSetting()
  },
  methods: {
    setBtns() {
      // useBtnList에서 받은 id로 필터링
      // console.log('this.buttonList ', this.buttonList )
      // this.buttonList = this.buttonList.filter(btn => {
      //   return this.useBtnList.includes(btn.id)
      // })

      let btns = []

      this.customBtnList.forEach(customBtn => {
        this.buttonList.push(customBtn)
      })

      this.useBtnList.forEach(useBtn => {
        if(this.$_.some(this.buttonList, { id: useBtn })) {
          // console.log('useBtn', useBtn)

          btns.push(this.buttonList.filter(btn => {
            return btn.id === useBtn
          })[0])
        }
      })

      // console.log('btns', btns)

      this.buttonList = btns
    },
    clickButton(targetButton) {
      this.$emit('btnClick', targetButton)
    },
    clickRefresh() {
      this.$emit('btnRefreshClick')
    },
    //각 메뉴별 조회, 추가, 저장, 삭제 정보 조회
    getAuthority() {
      // 조회 api
      // 사용자권한메뉴조회
      let authGrps = JSON.parse(localStore.get('myAuthGrps')).find(x => x.progCd == this.progCd && x.menuId == this.menuId)
      if (authGrps != null) {
        this.schAh = authGrps.schAh
        this.savAh = authGrps.savAh
        this.delAh = authGrps.delAh
        this.exlAh = authGrps.exlAh
      }

      //버튼권한별 View
      let authButtonList = this.buttonList.filter(btn => {
        if (
          (btn.id == 'btnSearch' && this.schAh == 'Y') ||
          (btn.id == 'btnAdd' && this.savAh == 'Y') ||
          (btn.id == 'btnSave' && this.savAh == 'Y') ||
          (btn.id == 'btnDelete' && this.delAh == 'Y') ||
          (btn.id == 'btnPrint' && this.savAh == 'Y') ||
          (btn.id == 'btnConfirm' && this.savAh == 'Y') ||
          (btn.id == 'btnApply' && this.savAh == 'Y') ||
          btn.id == 'btnCapture' ||
          btn.id == 'btnEditCancel' ||
          btn.id == 'btnCopy' ||
          btn.id == 'btnDataSearch'
        ) {
          return this.useBtnList.includes(btn.id)
        }
      })
      this.buttonList = authButtonList
    },

    // 레포트용 출력 설정
    printSetting() {
      let findIndex = this.buttonList.findIndex(element => element.id === 'btnPrint')
      this.buttonList
      if (findIndex > -1) {
        this.usePrint = true
        this.printButton = this.buttonList.find(element => element.id === 'btnPrint')
        this.reportItems.forEach(element => {
          Object.assign(element, this.printButton)
        })
        this.buttonList = this.buttonList.filter(element => element.id !== 'btnPrint')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// .v-btn {
  // background: #ffffff;
// }

.v-btn.v-size--default {
  font-size: 13px;
}

.report-menu {
  z-index: 10 !important;
}

.v-icon.v-icon {
  font-size: 20px;
  padding-right: 4px;
  padding-top: 3px;
}
</style>
